import { render, staticRenderFns } from "./MutedIcon.vue?vue&type=template&id=51cf22ed&"
import script from "./MutedIcon.vue?vue&type=script&lang=js&"
export * from "./MutedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports